// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__Q0kgm","menu__header":"Menu_menu__header__nnSiz","menu__icons":"Menu_menu__icons__Noo8p","menu__list":"Menu_menu__list__ON8BH"};